module.exports = __webpack_public_path__ + "static/media/circle.vertex.86a42e96.glsl";